import React from 'react'
import { Link, LinkProps, Route, Routes } from 'react-router-dom'
import { Box, BoxProps, Image } from 'theme-ui'
import { BiLogIn } from 'react-icons/bi'
import SidebarMenu from './SidebarMenu'
import LandingPageSidebarMenu from './LandingPageSidebarMenu'
import src from '../../images/wbs-bpkh.png'

export default function LandingPageHeader() {
  return (
    <Box
      bg="primary"
      sx={{
        height: 5,
        width: '100%',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        display: 'flex',
        color: 'white',
        alignItems: 'center',
      }}
      px={[1, 6]}
    >
      <Box sx={{ flexGrow: 1 }}>
        <Menu
          to="/"
          sx={{
            fontSize: 3,
            justifyContent: 'start',
            color: 'white !important',
          }}
        >
          <Image width={80} height={80} src={src}></Image>
        </Menu>
      </Box>

      <Box sx={{ display: ['none', 'flex'] }}>
        <Routes>
          <Route path="login"></Route>
          <Route
            path="/*"
            element={
              <>
                <Menu to="/">Beranda</Menu>
                <Menu to="about">Tentang</Menu>
                {/* <Menu to="disclaimer">Disclaimer</Menu> */}
                <Menu to="mechanism">Mekanisme</Menu>
                <Menu to="definition">Definisi Pelanggaran</Menu>
                <Menu to="login">
                  <Box as={BiLogIn} mr={2} /> Login
                </Menu>
              </>
            }
          ></Route>
        </Routes>
      </Box>

      <Box sx={{ display: ['block', 'none'] }}>
        <LandingPageSidebarMenu />
      </Box>
    </Box>
  )
}

interface MenuProps extends BoxProps {
  to: LinkProps['to']
}

function Menu(props: MenuProps) {
  return (
    <Box
      as={Link}
      {...props}
      px={2}
      color="white"
      sx={{
        textDecoration: 'none',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        ':hover': {
          color: 'secondary',
        },
        ...props.sx,
      }}
    />
  )
}
